import React from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { List, ListItem, ListItemIcon, useMediaQuery } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  rootGeneral: {
    flexGrow: 1,
    margin: '1% 2%',
    FontFace: 'font-family: "Roboto","Helvetica","Arial",sans-serif;',
    [theme.breakpoints.down('md')]: {
      margin: '2% 1%',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '1% 0.5%',
    },
  },
  root: {
    flexGrow: 1,
    margin: '0 2%',
    padding: '0 3% 5% 3%',
    [theme.breakpoints.down('sm')]: {
      margin: '0 1%',
      padding: '0 2% 3% 2%',
    },
  },
  nav: {
    width: '100%',
  },
  articleText: {
    lineHeight: '1.5em',
    fontSize: '1.3em',
    textAlign: 'justify',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.1em',
      lineHeight: '1.4em',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1em',
      textAlign: 'left',
    },
  },
  fieldset: {
    border: '4px solid #26516F',
    borderRadius: '50px',
    margin: '10px 20px',
    [theme.breakpoints.down('md')]: {
      margin: '10px 15px',
      borderRadius: '30px',
      border: '3px solid #26516F',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '10px 5px',
      borderRadius: '20px',
      border: '2px solid #26516F',
    },
  },
  legend: {
    color: '#26516F',
    fontSize: '2em',
    fontWeight: '700',
    marginLeft: '30px',
    padding: '0 10px',
    maxWidth: '180px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5em',
      marginLeft: '15px',
      padding: '0 5px',
      maxWidth: '140px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.3em',
      marginLeft: '10px',
      maxWidth: '120px',
    },
  },
  article: {
    fontSize: '1.8em',
    fontWeight: '600',
    textDecoration: 'underline',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.4em',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.2em',
    },
  },
}));

function AboutUsSSDD() {
  const classes = useStyles();
  const isMobile = useMediaQuery('(max-width:600px)');
  const isTablet = useMediaQuery('(max-width:960px)');

  return (
    <div className={classes.rootGeneral}>
      <div className={classes.nav}>

        {/*ABOUT US*/}
        <Grid item l={12} xs={12}>
          <fieldset className={classes.fieldset}>
            <legend className={classes.legend}>About Us</legend>
            <div className={classes.root}>
              <Box textAlign="justify">
                <Box mb={isMobile ? 2 : 3}>
                  <Typography 
                    variant={isMobile ? "h6" : "h5"} 
                    fontWeight="bold" 
                    style={{ textDecoration: 'underline' }} 
                    mb={1}
                    sx={{ fontSize: isMobile ? '1.1rem' : '1.5rem' }}
                  >
                    Description
                  </Typography>
                  <Typography 
                    variant="body1"
                    sx={{ 
                      fontSize: isMobile ? '0.9rem' : '1rem',
                      lineHeight: isMobile ? '1.4' : '1.5',
                      textAlign: isMobile ? 'left' : 'justify',
                    }}
                  >
                    Kabahagi Center for Children with Disabilities (KABAHAGI) promotes the rights of Children with Disabilities
                    who are aged younger than 18 years old and residing in Quezon City with their families, to achieve their holistic
                    and inclusive development through their participation in projects that are responsive to their needs in the
                    areas of education, health, livelihood, social empowerment.
                  </Typography>
                </Box>
                <Box mb={isMobile ? 2 : 3}>
                  <Typography 
                    variant={isMobile ? "h6" : "h5"} 
                    fontWeight="bold" 
                    style={{ textDecoration: 'underline' }} 
                    mb={1}
                    sx={{ fontSize: isMobile ? '1.1rem' : '1.5rem' }}
                  >
                    Mission
                  </Typography>
                  <Typography 
                    variant="body1"
                    sx={{ 
                      fontSize: isMobile ? '0.9rem' : '1rem',
                      lineHeight: isMobile ? '1.4' : '1.5',
                      textAlign: isMobile ? 'left' : 'justify',
                    }}
                  >
                    To recognize the rights of all children through its commitment to improving their quality of life through
                    community empowerment, provision of services, and creation of equal access to health, education, livelihood,
                    and social opportunities.
                  </Typography>
                </Box>
                <Box mb={isMobile ? 2 : 3}>
                  <Typography 
                    variant={isMobile ? "h6" : "h5"} 
                    fontWeight="bold" 
                    style={{ textDecoration: 'underline' }} 
                    mb={1}
                    sx={{ fontSize: isMobile ? '1.1rem' : '1.5rem' }}
                  >
                    Vision
                  </Typography>
                  <Typography 
                    variant="body1"
                    sx={{ 
                      fontSize: isMobile ? '0.9rem' : '1rem',
                      lineHeight: isMobile ? '1.4' : '1.5',
                      textAlign: isMobile ? 'left' : 'justify',
                    }}
                  >
                    Kabahagi envisions a city that is inclusive, sustainable, empowering, and participatory where Persons with
                    Disabilities have equal access to opportunities, rights, and privileges.
                  </Typography>
                </Box>
                <Box mb={isMobile ? 2 : 3}>
                  <Typography 
                    variant={isMobile ? "h6" : "h5"} 
                    fontWeight="bold" 
                    style={{ textDecoration: 'underline' }} 
                    mb={1}
                    sx={{ fontSize: isMobile ? '1.1rem' : '1.5rem' }}
                  >
                    Legal Bases
                  </Typography>
                  <ul style={{ 
                    paddingLeft: isMobile ? '16px' : '18px',
                    margin: 0,
                  }}>
                    <li style={{ paddingBottom: isMobile ? '8px' : '10px' }}>
                      <Typography 
                        variant="body1"
                        sx={{ 
                          fontSize: isMobile ? '0.9rem' : '1rem',
                          lineHeight: isMobile ? '1.4' : '1.5',
                        }}
                      >
                        Section 6 (8) of Ordinance No. SP-1915, S-2009 (The Special Children's Ordinance of Quezon City) which states that
                        the City shall provide easy access to educational and rehabilitation services to special children and their families;
                      </Typography>
                    </li>
                    <li style={{ paddingBottom: isMobile ? '8px' : '10px' }}>
                      <Typography 
                        variant="body1"
                        sx={{ 
                          fontSize: isMobile ? '0.9rem' : '1rem',
                          lineHeight: isMobile ? '1.4' : '1.5',
                        }}
                      >
                        Section 17 of Ordinance No. SP-2180, S-2012, as amended (The Quezon City Children's Code of 2012) which states that
                        the Quezon City Government shall provide an integrated health service for children with disabilities which shall
                        include early detection of disability and timely intervention;
                      </Typography>
                    </li>
                    <li style={{ paddingBottom: isMobile ? '8px' : '10px' }}>
                      <Typography 
                        variant="body1"
                        sx={{ 
                          fontSize: isMobile ? '0.9rem' : '1rem',
                          lineHeight: isMobile ? '1.4' : '1.5',
                        }}
                      >
                        Quezon City Ordinance No. SP-2617, S-2017, as amended by City Ordinance No. SP-2718, S-2018 – An Ordinance
                        Institutionalizing A Comprehensive Program for Children with Disabilities (CWDs), Thereby Establishing A Center and
                        Providing Funds Thereof and for Other Purposes.
                      </Typography>
                    </li>
                  </ul>
                </Box>
                <Box mb={isMobile ? 2 : 3}>
                  <Typography 
                    variant={isMobile ? "h6" : "h5"} 
                    fontWeight="bold" 
                    style={{ textDecoration: 'underline' }} 
                    mb={1}
                    sx={{ fontSize: isMobile ? '1.1rem' : '1.5rem' }}
                  >
                    Service Pledge:
                  </Typography>
                  <Typography 
                    variant="body1" 
                    mb={1}
                    sx={{ 
                      fontSize: isMobile ? '0.9rem' : '1rem',
                      lineHeight: isMobile ? '1.4' : '1.5',
                      textAlign: isMobile ? 'left' : 'justify',
                    }}
                  >
                    Quezon City Kabahagi Center for Children with Disability is committed to upholding the rights of children with
                    disabilities.
                  </Typography>
                  <ul style={{ 
                    paddingLeft: isMobile ? '16px' : '18px',
                    margin: 0,
                  }}>
                    <li style={{ paddingBottom: isMobile ? '8px' : '10px' }}>
                      <Typography 
                        variant="body1"
                        sx={{ 
                          fontSize: isMobile ? '0.9rem' : '1rem',
                          lineHeight: isMobile ? '1.4' : '1.5',
                        }}
                      >
                        We shall strengthen advocacy for an inclusive society where children with disabilities may develop their full
                        potential.
                      </Typography>
                    </li>
                    <li style={{ paddingBottom: isMobile ? '8px' : '10px' }}>
                      <Typography 
                        variant="body1"
                        sx={{ 
                          fontSize: isMobile ? '0.9rem' : '1rem',
                          lineHeight: isMobile ? '1.4' : '1.5',
                        }}
                      >
                        We shall provide quality and prompt delivery of service specific to the disability needs of the children.
                      </Typography>
                    </li>
                    <li style={{ paddingBottom: isMobile ? '8px' : '10px' }}>
                      <Typography 
                        variant="body1"
                        sx={{ 
                          fontSize: isMobile ? '0.9rem' : '1rem',
                          lineHeight: isMobile ? '1.4' : '1.5',
                        }}
                      >
                        We shall ensure that qualified staff is available to provide supportive services.
                      </Typography>
                    </li>
                    <li style={{ paddingBottom: isMobile ? '8px' : '10px' }}>
                      <Typography 
                        variant="body1"
                        sx={{ 
                          fontSize: isMobile ? '0.9rem' : '1rem',
                          lineHeight: isMobile ? '1.4' : '1.5',
                        }}
                      >
                        We shall strengthen our advocacy efforts towards the development of policies and practices that are for
                        and by the Children with Disability and their families.
                      </Typography>
                    </li>
                    <li style={{ paddingBottom: isMobile ? '8px' : '10px' }}>
                      <Typography 
                        variant="body1"
                        sx={{ 
                          fontSize: isMobile ? '0.9rem' : '1rem',
                          lineHeight: isMobile ? '1.4' : '1.5',
                        }}
                      >
                        We are dedicated to forging partnerships with relevant stakeholders that embrace the same thrust for
                        inclusive development.
                      </Typography>
                    </li>
                  </ul>
                </Box>
              </Box>
            </div>
          </fieldset>
        </Grid>

      </div>
    </div>
  );
}

export default AboutUsSSDD;
